export default __webpack_public_path__ + "static/supportImg-38a5be07a62511ee05cccac5e3297c6c.svg";